module.exports = __webpack_public_path__ + "img/icon-mobile.78875a61.svg";